import React from 'react';

export default class SideNav extends React.Component {
	constructor(props) {
		super(props);

		const data = this.props.data || [];

		this.state = {
			data: data,
			loading: data && data.length ? false : true
		};

		this.loadData = this.loadData.bind(this);
	}

	componentDidMount() {
		if (!this.state.data || this.state.data.length === 0) {
			this.loadData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.endpoint !== this.props.endpoint) {
			this.loadData();
		}
	}

	render() {
		// console.log(this.props)

		return (
			<div className="UserNav">
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
					</div>
				) : null}
				<div className="title-container">
					<span className="title">NAVIGATION</span>
				</div>
				<ul className="links-container">
					<li className="link">{this.props.section1of3}</li>
					<li className="link">{this.props.section2of3}</li>
					<li className="link">{this.props.section3of3}</li>
				</ul>
			</div>
		);
	}

	loadData() {
		this.setState({ loading: true });
		$.ajax({
			type: 'POST',
			url: this.props.endpoint
		}).done((data) => {
			//console.log('UserBasics loadData done', data);
			this.setState({ data: data, loading: false });
		});
	}
}
